module.exports = __webpack_public_path__ + "img/equipos-moviles-img-7.423b1339.jpg";